import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        overflowX: 'hidden',
    },
    container: {
        paddingTop: theme.spacing(0.2),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(0),
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 600,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    fixedHeightTables: {
        height: 210,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    containerSelect: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        textAlign:'center',
        justifyContent: 'center',
    },
}));